import { getOptimizedImages } from 'common/hooks/use-optimized-images';
import { parseFloatValue, stringIsNumber } from 'utils';
import { AxisPoint, PointData } from './types';
import { VariantsAxisModel } from 'features/variants';

export const sortAxis = (poa: PointData[]): AxisPoint[] => {
  return processAxisPoints(poa);
};

export const processAxisPoints = (pointsOnAxis: PointData[]): AxisPoint[] => {
  let isSortByAxis = true;

  const axisPoints = pointsOnAxis.map((pointData) => {
    if (!stringIsNumber(pointData.label)) {
      isSortByAxis = false;
    }

    const optimizedThumb = getOptimizedImages(pointData.mainPhoto, {
      thumb: {
        w: '42',
        h: '42',
      },
    });

    return {
      axis: pointData.axis,
      src: optimizedThumb.thumb.xx || '',
      toProductUrl: pointData.toProductUrl,
      label: pointData.label,
      isPuncturedPoint: pointData.isPuncturedPoint,
      displayedName: pointData.displayedName,
      productPrice: pointData.productPrice,
      productId: pointData.productId,
      productBelong: pointData.productBelong,
    };
  });

  if (isSortByAxis) {
    axisPoints.sort((a, b) => parseFloatValue(a.label) - parseFloatValue(b.label));
  } else {
    axisPoints.sort((a, b) => Number(a.productId) - Number(b.productId));
  }

  return axisPoints;
};

export const countAxisPoints = (variantsModel?: VariantsAxisModel[]) => {
  if (!variantsModel || !variantsModel.length || variantsModel.length === 0) {
    return 0;
  }
  /**
   * NOTE: для пустых осей вернет +1, нужно на случай пустых осей у товара, чтобы отображать варианты
   * см. тесткейс should handle mixed scenarios with some axes having points and some not
   *  */
  return variantsModel.reduce((acc, axis) => acc + (axis?.pointsOnAxis?.length || 1), 0);
};

export const calculateHideAxis = (variantsModel?: VariantsAxisModel[]) => {
  if (!variantsModel || !variantsModel.length || variantsModel.length === 0) {
    return true;
  }
  return variantsModel.length >= countAxisPoints(variantsModel);
};
